import React, { useEffect, useRef, useState } from 'react';
import { AvatarComponent } from './components/avatar.component';
import { getConsumer } from '../../../channels/consumer';

type Aluno = any;

interface Props {
  alunos: Aluno[];
  program_class_id?: number | string;
  programClassId?: number | string;
  alunos_url?: string;
  alunosUrl?: string;
}

const AlunosNaAula = ({ alunos, program_class_id, programClassId, alunos_url, alunosUrl }: Props) => {
  const channelId = programClassId ?? program_class_id;
  const refetchUrl = alunosUrl ?? alunos_url;
  const [currentAlunos, setCurrentAlunos] = useState<Aluno[]>(alunos || []);
  const inFlight = useRef(false);
  const pending = useRef(false);

  useEffect(() => {
    setCurrentAlunos(alunos || []);
  }, [alunos]);

  useEffect(() => {
    if (!channelId || !refetchUrl) return undefined;

    const fetchAlunos = () => {
      if (inFlight.current) {
        pending.current = true;
        return;
      }
      inFlight.current = true;
      fetch(refetchUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (data && Array.isArray(data.alunos)) {
            setCurrentAlunos(data.alunos);
          }
        })
        .catch(() => undefined)
        .finally(() => {
          inFlight.current = false;
          if (pending.current) {
            pending.current = false;
            fetchAlunos();
          }
        });
    };

    const subscription = getConsumer().subscriptions.create(
      { channel: 'CheckinsNowChannel', program_class_id: channelId },
      {
        received(data: { refresh?: boolean; alunos?: Aluno[] }) {
          if (data && Array.isArray(data.alunos)) {
            setCurrentAlunos(data.alunos);
            return;
          }
          if (data && data.refresh) {
            fetchAlunos();
          }
        },
      },
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [channelId, refetchUrl]);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', flex: 1 }}>
      {currentAlunos?.map((aluno: Aluno) => (
        <AvatarComponent key={aluno.id} aluno={aluno} countCheckins />
      ))}
    </div>
  );
};

export default AlunosNaAula;
